import { createReqConsts, createActions } from '../../utils/redux';

export const consts = createReqConsts('auth', 'login-azure', [
  'INIT',
  'SET_CREDENTIAL_FOR_MFA',
  'SET_SUCCESS_SIGN_UP_FLOW',
]);

export const actions = createActions(consts);



// WEBPACK FOOTER //
// ./src/redux/auth/authAzure.js